/**
 * @fileoverview REPSE, delivery time, sales volume, and payment method selects.
 */

import Select from "react-select";
import {
  getSelectedOption,
  selectStyles,
  shouldHideFieldForProfile,
} from "../../../utils/common";
import styles from "./Certifications.module.css";

/** Translation key for the "not visible field" message */
const NOT_VISIBLE_FIELD_MESSAGE_KEY =
  "components.corporateIdentity.notVisibleFieldMessage";

const DeliveryAndSalesFields = ({ section, selectedProfile }) => {
  const {
    t,
    handleInputChange,
    esProveedorREPSE,
    setEsProveedorREPSE,
    REPSEProviderOptions,
    tiemposPromedioEntrega,
    setTiemposPromedioEntrega,
    averageDeliveryTimesOptions,
    volumenDeVentasAnuales,
    setVolumenDeVentasAnuales,
    annualSalesVolumeOptions,
    metodosDePagoAceptados,
    setMetodosDePagoAceptados,
    acceptedPaymentMethodsOptions,
  } = section;

  return (
    <div className={styles.inputRow}>
      {!shouldHideFieldForProfile("esProveedorREPSE", selectedProfile) && (
        <div className={styles.inputGroup}>
          <label className={styles.inputLabel}>
            {t("components.certifications.REPSEProviderLabel")}
          </label>
          <Select
            value={getSelectedOption(REPSEProviderOptions, esProveedorREPSE)}
            options={REPSEProviderOptions}
            placeholder={t(
              "components.certifications.REPSEProviderPlaceholder",
            )}
            styles={selectStyles}
            className="select__control"
            onChange={(selectedOption) => {
              setEsProveedorREPSE(selectedOption.value);
              handleInputChange("esProveedorREPSE", selectedOption.value);
            }}
          />
          <p className={styles.notVisibleFieldMessage}>
            *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
          </p>
        </div>
      )}
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.certifications.averageDeliveryTimesLabel")}
        </label>
        <Select
          value={getSelectedOption(
            averageDeliveryTimesOptions,
            tiemposPromedioEntrega,
          )}
          options={averageDeliveryTimesOptions}
          placeholder={t(
            "components.certifications.averageDeliveryTimesPlaceholder",
          )}
          styles={selectStyles}
          className="select__control"
          onChange={(selectedOption) => {
            setTiemposPromedioEntrega(selectedOption.value);
            handleInputChange("tiemposPromedioEntrega", selectedOption.value);
          }}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.certifications.annualSalesVolumeLabel")}
        </label>
        <Select
          value={getSelectedOption(
            annualSalesVolumeOptions,
            volumenDeVentasAnuales,
          )}
          options={annualSalesVolumeOptions}
          placeholder={t(
            "components.certifications.annualSalesVolumePlaceholder",
          )}
          styles={selectStyles}
          className="select__control"
          onChange={(selectedOption) => {
            setVolumenDeVentasAnuales(selectedOption.value);
            handleInputChange("volumenDeVentasAnuales", selectedOption.value);
          }}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.certifications.acceptedPaymentMethodsLabel")}
        </label>
        <Select
          value={getSelectedOption(
            acceptedPaymentMethodsOptions,
            metodosDePagoAceptados,
          )}
          options={acceptedPaymentMethodsOptions}
          placeholder={t(
            "components.certifications.acceptedPaymentMethodsPlaceholder",
          )}
          styles={selectStyles}
          className="select__control"
          onChange={(selectedOption) => {
            setMetodosDePagoAceptados(selectedOption.value);
            handleInputChange("metodosDePagoAceptados", selectedOption.value);
          }}
        />
        <p className={styles.notVisibleFieldMessage}>
          *{t(NOT_VISIBLE_FIELD_MESSAGE_KEY)}
        </p>
      </div>
    </div>
  );
};

export default DeliveryAndSalesFields;
